// ABOUTME: The extended view preference, offered on the schedule it governs rather than a page of its own.
// ABOUTME: Saved for the user, so it survives the session — the schedule's other controls do not.

import { Flex, Icon, Toggle, Tooltip } from "@nulogy/components";
import useExtendedView, { EXTENDED_VIEW_DESCRIPTION, EXTENDED_VIEW_LABEL } from "hooks/apollo/user/useExtendedView";
import React from "react";
import styled from "styled-components";

// A button, so the description the Preferences page spelled out under the toggle is reachable by keyboard
// and announced, rather than resting on a hover the icon alone cannot invite.
const DescriptionTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  cursor: help;

  /* The disc stands taller than the label's capitals, so centring it on the row leaves it riding above them.
     A pixel down evens up what it overshoots at the cap against what it overshoots past the baseline. */
  position: relative;
  top: 1px;
`;

export default function ExtendedViewToggle({ disabled }) {
  const { extendedView, loading, updateExtendedView } = useExtendedView();

  return (
    <Flex alignItems="center" gap="half">
      {/* toggled, not checked: passing toggled is what puts NDS's Toggle in its controlled mode. Without it the
          switch keeps state of its own, seeded from a defaultToggled we never pass, and draws itself off
          whatever the saved preference is — while an unrecognised checked prop still reaches the input. */}
      <Toggle
        aria-label={EXTENDED_VIEW_LABEL}
        disabled={disabled || loading}
        offText={EXTENDED_VIEW_LABEL}
        onChange={updateExtendedView}
        onText={EXTENDED_VIEW_LABEL}
        py="none"
        toggled={extendedView}
      />
      {/* Describing the preference stays available while the schedule navigates, which is when the toggle
          itself does not. */}
      <Tooltip placement="bottom" tooltip={EXTENDED_VIEW_DESCRIPTION}>
        <DescriptionTrigger aria-label="About extended view" type="button">
          <Icon color="darkBlue" icon="help" size="16px" />
        </DescriptionTrigger>
      </Tooltip>
    </Flex>
  );
}
